export default "__VITE_ASSET__820ce03a__"